import axios from 'axios';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

interface UploadFileAttrs {
  venue_id?: string;
  service_provider_id?: string;
  file: File;
  title?: string;
  category?: string;
  description?: string;
}

export async function uploadFile({
  venue_id,
  service_provider_id,
  file,
  title,
  category,
  description,
}: UploadFileAttrs) {
  const name = file.name;
  const size = file.size;
  const type = venue_id ? 'venue' : 'service_provider';
  const path = `${type}/${venue_id || service_provider_id}/${name}`;

  const storage = getStorage();
  const storageRef = ref(storage, path);

  const upload = await uploadBytes(storageRef, file);

  const payload = {
    venue_id,
    service_provider_id,
    path,
    title,
    name,
    size,
    category,
    description,
  };
  // https://www.iccsydney.com.au/app/venue-map

  if (upload) {
    const response = await axios.post('/api/file', payload);
    return { ...upload.metadata, ...payload, url: path, ...response.data };
  } else {
    return 'upload failed';
  }
}

export async function updateFile(id: string, data: Partial<UploadFileAttrs>) {
  const response = await axios.patch(`/api/file/${id}`, {
    category: data.category,
    description: data.description,
    name: data.title,
  });
  return response.data;
}

export async function deleteFile(file_id: string) {
  await axios.delete(`/api/file/${file_id}`);
  return file_id;
}

export async function getDownloadUrl(path: string) {
  const storage = getStorage();
  const storageRef = ref(storage, path);
  const url = await getDownloadURL(storageRef);
  return url;
}

export async function downloadFile(href: string) {
  if (!href) {
    return 'invalid href';
  }

  const downloadUrl = await getDownloadUrl(href);

  const anchor = document.createElement('a');
  anchor.href = downloadUrl;
  anchor.setAttribute('download', href.split('/').pop()!);
  anchor.click();

  return downloadUrl;
}

export const convertBytes = (bytes: number, toUnit: string) => {
  const div = toUnit === 'MB' ? 1000000 : 1000;
  return Math.floor(((bytes / div + Number.EPSILON) * 100) / 100); //Math.round(bytes / 1000000);
};

export const sizeToString = (size: number) => {
  const unit = size >= 1000000 ? 'MB' : 'KB';
  const sizeStr = convertBytes(size, unit);
  return `${sizeStr.toFixed(2).replace('.00', '')} ${unit}`;
};
